var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"drag"},[_vm._t("line-top"),_c('div',{staticClass:"edge-line",on:{"mousedown":function($event){$event.stopPropagation();$event.preventDefault();return _vm.moveVertical($event)}}}),_vm._t("line-bottom")],2)}
var staticRenderFns = []

export { render, staticRenderFns }